var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"point little-round act",class:{ test: _vm.p.color === '?' },style:({ backgroundColor: _vm.p.color }),on:{"click":function($event){_vm.click && _vm.click({ x: _vm.p.x, y: _vm.p.y })},"mouseenter":_vm.handleMousePresense,"mouseleave":_vm.handleMousePresense}},[_c('div',{staticClass:"content flex-row-center"},[_vm._v(_vm._s(_vm.p.x)),_c('span'),_vm._v(_vm._s(_vm.p.y))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667104b6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/UI/PointLabel.vue
// module id = null
// module chunks = 